import { useDashboardContext } from '@/contexts/DashboardContexProvider';
import { AuthorityCodesDashboard } from '@/core/domain/enterprise/Authority/Authority.types';
import { useWindowSize } from '@/hooks';
import { AuthoritiesType } from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Dropdown, Menu, Tooltip } from 'antd';
import { FaChartBar } from 'react-icons/fa';

export default function SelectDashboardType() {
  const { isMobile } = useWindowSize();
  const { dashboardType, setDashboardType } = useDashboardContext();

  const options = [
    {
      value: AuthorityCodesDashboard.managerView,
      label: 'Dashboard Gerencial',
    },
    {
      value: AuthorityCodesDashboard.financialView,
      label: 'Dashboard Financeiro',
    },
    {
      value: AuthorityCodesDashboard.estimatorView,
      label: 'Dashboard Orçamento',
    },
    {
      value: AuthorityCodesDashboard.defaultView,
      label: 'Dashboard Padrão',
    },
  ];

  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu activeKey={dashboardType}>
          {options?.map((dashboardType) => (
            <Menu.Item
              key={dashboardType.value}
              onClick={() => setDashboardType(dashboardType.value)}
              disabled={
                !hasPermissions([
                  dashboardType.value as unknown as AuthoritiesType,
                ])
              }
            >
              {dashboardType.label}
            </Menu.Item>
          ))}
        </Menu>
      }
      placement="bottom"
      arrow
    >
      <Tooltip overlay={!isMobile && 'Selecionar Dashboards'}>
        <Button
          block={isMobile}
          size="large"
          icon={
            <FaChartBar
              style={{
                marginTop: !isMobile ? '5px' : undefined,
              }}
            />
          }
          type="primary"
        >
          {isMobile && 'Selecionar Dashboards'}
        </Button>
      </Tooltip>
    </Dropdown>
  );
}
